export default function isInViewDistance(widgetUuid, factor) {
  // always lazy load
  factor = factor || 0

  // math.floor is necessary because getBoundingClientRect and pageYOffset can return floats which are not pixel perfect
  const widgetOffsetY = Math.floor(window._8select.utils.widgetLoader.getWidgetOffset(widgetUuid))
  const viewOffsetY = Math.floor(window.pageYOffset)
  const viewHeight = window.innerHeight

  return viewOffsetY + widgetOffsetY <= viewOffsetY + viewHeight + viewHeight * factor
}
